const loadData = async () => {
    if (window.WCCP_DATA) return window.WCCP_DATA;
    const url = root.getAttribute('data-json');
    if (!url) throw new Error('No data source: set window.WCCP_DATA or data-json on #wccp-composite-root');
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to load JSON: ' + res.status);
    return await res.json();
};

const normalize = (raw) => {
    const d = JSON.parse(JSON.stringify(raw));

    (d.components || []).forEach(c => {
        c.id = Number(c.id);
        if (c.default_product != null) c.default_product = Number(c.default_product);

        (c.products || []).forEach(p => {
            p.product_id = Number(p.product_id);
            if (p.price != null) p.price = Number(p.price);
            if (p.name == null && p.title != null) p.name = p.title;
            p.is_variable = !!p.is_variable;
            p.labels = Array.isArray(p.labels) ? p.labels : [];

            if (!Array.isArray(p.variations)) p.variations = [];
            p.variations.forEach(v => {
                v.variation_id = Number(v.variation_id);
                if (v.price != null) v.price = Number(v.price);
                if (v.attributes == null || typeof v.attributes !== 'object') v.attributes = {};
            });
        });

        if (c.name == null && c.title != null) c.name = c.title;
    });




    // Scenarios arrive grouped per component (product_ids) to keep the page small; expand to one entry per product.
    (d.scenarios || []).forEach(sc => {
        sc.available_components = (sc.available_components || []).flatMap(ac => Array.isArray(ac.product_ids)
            ? ac.product_ids.map(pid => ({ component_id: ac.component_id, min_qty: ac.min_qty, max_qty: ac.max_qty, product_id: pid }))
            : [ac]);
    });

    const acLookup = new Map();
    (d.scenarios || []).forEach(sc => {
        (sc.available_components || []).forEach(entry => {
            const key = `${Number(entry.component_id)}:${Number(entry.product_id)}`;
            // Product details are sent once in product_meta (deduplicated); older cache files still carry them per entry.
            const ac = (d.product_meta && d.product_meta[key]) ? { ...entry, ...d.product_meta[key] } : entry;
            const prev = acLookup.get(key) || {};

            const vlist = Array.isArray(ac.variations) ? ac.variations.map(v => ({
                variation_id: Number(v.variation_id),
                attributes: (v.attributes && typeof v.attributes === 'object') ? v.attributes : {},
                price: v.price != null ? Number(v.price) : undefined,
                thumbnail_url: v.thumbnail_url ?? null
            })) : [];
            acLookup.set(key, {
                name: ac.name ?? prev.name ?? null,
                thumbnail_url: ac.thumbnail_url ?? prev.thumbnail_url ?? null,
                is_variable: (ac.is_variable != null ? Boolean(ac.is_variable) : prev.is_variable),
                variations: vlist.length ? vlist : (prev.variations || []),
                labels: ac.labels ?? prev.labels ?? [],
            });
        });
    });

    (d.components || []).forEach(c => {
        (c.products || []).forEach(p => {
            const key = `${Number(c.id)}:${Number(p.product_id)}`;
            const meta = acLookup.get(key);

            p.is_variable = Boolean(p.is_variable);
            if (!Array.isArray(p.variations)) p.variations = [];

            if (meta) {
                if ((p.name == null || p.name === '') && meta.name != null) p.name = meta.name;
                if ((p.thumbnail_url == null || p.thumbnail_url === '') && meta.thumbnail_url != null) p.thumbnail_url = meta.thumbnail_url;
                if (meta.is_variable != null) p.is_variable = Boolean(p.is_variable || meta.is_variable);
                if (!p.variations.length && Array.isArray(meta.variations)) p.variations = meta.variations;
                if (!p.labels.length && Array.isArray(meta.labels)) p.labels = meta.labels;
            }

            if (p.is_variable && !Array.isArray(p.variations)) p.variations = [];
        });
    });

    return d;
};